export const translateSaleStatus: { [key: string]: string } = {
  0: "Cancelada",
  1: "En proceso",
  2: "Pagada",
  3: "Reembolso Pendiente",
  4: "Reembolsada",
  5: "Parcialmente Pagada",
  6: "Cuenta Abierta",
  7: "Expirada",
  8: "Por confirmar",
};

export const getTranslatedSaleStatus = (status: number): string => {
  return translateSaleStatus[status] || "Desconocido";
};

// Modality of the app order behind a sale; mirrors the API AppOrderType enum
export const translateAppOrderType: { [key: string]: string } = {
  1: "En evento",
  2: "Pre-orden",
};

export const getTranslatedAppOrderType = (
  orderType?: number | null,
): string => {
  return orderType ? translateAppOrderType[orderType] || "" : "";
};

// App sales are all sold by the same virtual seller ("App Channel"), so the modality is what
// tells a pre-order apart from an in-event one. Terminal sales have none.
export const getSellerNameWithAppOrderType = (
  sellerName: string,
  orderType?: number | null,
): string => {
  const appOrderTypeLabel = getTranslatedAppOrderType(orderType);
  return appOrderTypeLabel ? `${sellerName} (${appOrderTypeLabel})` : sellerName;
};

// Status of the app order behind a sale. The wording is the one the customer reads on the
// order detail of the BM app, so support and the customer name the same thing.
export const translateAppOrderStatus: { [key: string]: string } = {
  pending_payment: "Pago pendiente",
  payment_failed: "Pago rechazado",
  scheduled: "Programado",
  accepted: "Pedido aceptado",
  in_preparation: "En cocina",
  ready: "Pedido listo",
  in_delivery: "Runner en camino",
  at_pickup_zone: "Listo para recoger",
  delivered: "Entregado",
  picked_up: "Entregado",
  cancelled: "Cancelado",
  refund_pending: "Reembolso en proceso",
  refunded: "Reembolsado",
};

export const getTranslatedAppOrderStatus = (status: string): string => {
  return translateAppOrderStatus[status] || "En proceso";
};

// Delivery method of the app order; mirrors the API AppOrderDeliveryMethod enum
export const translateAppOrderDeliveryMethod: { [key: string]: string } = {
  runner_to_seat: "Entrega en asiento",
  pickup_point: "Punto de recolección",
};

export const getTranslatedAppOrderDeliveryMethod = (
  deliveryMethod: string,
): string => {
  return translateAppOrderDeliveryMethod[deliveryMethod] || "-";
};

export const SALE_STATUS_KEY_TO_ID: Record<string, number> = {
  paid: 2,
  preauthorized: 1,
  parciallyPaid: 5,
  openBill: 6,
  pendingValidation: 8,
};
